const _import = require('../import-' + process.env.NODE_ENV)

const workorderRouter = [
  {
    path: '/workorder/index',
    name: 'workorderIndex',
    component: _import('workorder/index'),
    meta: {
      title: '维修单',
      auth: true,
      keepAlive: true
    }
  },
  {
    path: '/workorder/create',
    name: 'workorderCreate',
    component: _import('workorder/create'),
    meta: {
      title: '发布维修单',
      auth: true
    }
  }
]
export default workorderRouter



// WEBPACK FOOTER //
// ./src/router/work/workorder.js